<style>
    @import '@/assets/css/custom.css';
    
    .hover-bg-light:hover {
        background-color: #f8f9fa !important;
    }
    
    .cursor-pointer {
        cursor: pointer;
    }
</style>

<template>
   <div>
       <Breadcrumbs main="Boards" title="Batch Details" />

       <div class="container-fluid">
           <div class="row">
               <div class="col-sm-12">
                   <div class="card">
                       <div class="card-body">
                           <!-- Batch Number Display -->
                           <div class="row mb-3">
                               <div class="col-md-8" v-if="batch_number">
                                    <div>
                                       Batch Number: <strong>{{ batch_number }}</strong><br>
                                       <span v-if="total_boards !== null">Total Boards: <strong>{{ total_boards }}</strong></span>
                                    </div>
                               </div>
                               <div class="col-md-4 text-end">
                                   <router-link :to="{ name: 'board_batches' }" class="btn btn-primary">
                                       <i class='bx bx-chevrons-left'></i> Back
                                   </router-link>
                               </div>
                           </div>
                        
                           <div class="col-md-12 project-list filter-sort">
                               <div class="row">
                                   <div class="col-md-10 d-flex mt-2">
                                       <label class="d-flex listing-length ms-1"><span>Show</span>
                                           <select class="form-select" v-model="listing_length" @change="fetchBatchDetails()">
                                               <option value="10">10</option>
                                               <option value="20">20</option>
                                               <option value="50">50</option>
                                               <option value="100">100</option>
                                               <option value="200">200</option>
                                           </select>
                                           <span>entries</span>
                                       </label>
                                   </div>
                                   <div class="col-md-2 mt-2">
                                       <input type="text" class="form-control ms-1" placeholder="Search" v-model="keyword" @keyup="fetchBatchDetails()"/>
                                   </div>
                               </div>
                           </div>

                           <div class="table-responsive product-table">
                               <table class="display" id="basic-1">
                                   <thead>
                                       <tr align="center">
                                           <th>Sl.No</th>  
                                           <th>Serial Number</th>
                                           <th>Vendor Name</th>
                                           <th>IMEI</th>
                                           <th>ICCID</th>
                                           <th>Date</th>
                                       </tr>
                                   </thead>
                                   <tbody v-if="Boolean(boards.length)">
                                       <tr v-for="(board, index) in boards" :key="board.id" align="center">
                                           <td>{{ index + 1 }}</td>
                                           <td>{{ board.serial_number }}</td>
                                           <td>{{ board.vendor_name }}</td>
                                           <td>{{ board.imei }}</td>
                                           <td>{{ board.iccid }}</td>
                                           <td>{{ $filters.formatDate(board.date) }}</td>
                                       </tr>
                                     
                                   </tbody>
                                   <tbody v-else>
                                       <tr>
                                           <td colspan="5" align="center">No data available</td>
                                       </tr>
                                   </tbody>
                               </table>
                           </div>

                           <!----pagination starts --->
                           <caption v-if="Boolean(boards.length)" class="float-start mt-2 d-block d-lg-inline">Showing {{this.from}} to {{this.to}} of {{this.total}} entries</caption>
                           <nav aria-label="Page navigation" class="mt-2 float-end">
                               <ul class="pagination">
                                   <li class="page-item" v-bind:class="[{ disabled: !page.url }, { active: page.active }]" v-for="(page, index) in pagination" :key="page.label">
                                       <a class="page-link" href="#" @click.prevent="fetchBatchDetails(page.url + '&limit=' + listing_length + '&keyword=' + keyword + '&batch_id=' + batch_id)" tabindex="-1">
                                           <span v-if="index == 0">Prev</span>
                                           <span v-else-if="index == pagination.length - 1">Next</span>
                                           <span v-else>{{ page.label }}</span>
                                       </a>
                                   </li>
                               </ul>
                           </nav>
                           <!----pagination ends --->
                           
                       </div>
                   </div>
               </div>
           </div>
       </div>


   </div>
</template>

<script>
   export default {
       name: "Batch Details",

       data() {
           return {
               keyword: "",
               listing_length: 10,
               token: "",
               batch_id: null,
               batch_number: "",
               total_boards: null,
               boards: [],
               pagination: {},
               from: 0,
               to: 0,
               total: 0,
           };
       },
       created() {
           this.batch_id = this.$route.params.id;
           this.fetchBatchDetails();
       },
       methods: {

           getToken() {
               if (localStorage.getItem('airotrack_staff')) {
                   var airotrack_staff =  JSON.parse(localStorage.getItem('airotrack_staff')); 
                           
                   if(airotrack_staff.token) {

                       this.token = airotrack_staff.token;
                       this.user = airotrack_staff;

                   } else {
                       this.$swal("", "Failed to fetch token, please login again", "error");
                       this.$router.push({ name: "login" });
                   }

               } else {
                   this.$swal("", "Session expired, please login again", "error");
                   this.$router.push({ name: "login" });
               }
           },
           
           fetchBatchDetails(page_url = null) {
               this.getToken();
               let url = "/staffs/batchBoardsDetail?batch_id=" + this.batch_id + "&limit=" + this.listing_length + "&keyword=" + this.keyword;
               page_url = page_url || url;
               this.active_page_url = page_url;
               this.$axios
                   .get(page_url, { headers: { Authorization: "Bearer " + this.token } })
                   .then((res) => {
                       var responseData = res.data.data;
                       console.log(responseData);
                       this.boards = responseData.batch_boards.data;
                       this.pagination = responseData.batch_boards.links;
                       this.from = responseData.batch_boards.from;
                       this.to = responseData.batch_boards.to;
                       this.total = responseData.batch_boards.total;
                       
                       // Get batch_number and total_boards from batch object if available
                       if (responseData.batch) {
                           if (responseData.batch.batch_number) {
                               this.batch_number = responseData.batch.batch_number;
                           }
                           if (responseData.batch.total_boards !== undefined) {
                               this.total_boards = responseData.batch.total_boards;
                           }
                       }
                   })
                   .catch((err) => console.log(err));
           },

       },
   };
</script>